module.exports = __webpack_public_path__ + "assets/img/discernment_clothing_describe.3e894e36.png";